import { render, staticRenderFns } from "./AdministratorsList.vue?vue&type=template&id=500a5ba5&"
import script from "./AdministratorsList.vue?vue&type=script&lang=js&"
export * from "./AdministratorsList.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports